export default "__VITE_ASSET__05cbeb34__"